var _rect, _path, _path2, _rect2, _rect3, _path3, _path4, _rect4, _rect5, _path5, _path6, _rect6, _path7, _rect7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 200,
    viewBox: "0 0 294 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 294,
    height: 200,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.002 29.6999C16.002 26.9429 18.2369 24.708 20.9938 24.708H165.209C167.965 24.708 170.2 26.9429 170.2 29.6999V37.9594H16.002V29.6999Z",
    fill: "#B9C7D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.199 59.4705C170.199 62.2275 167.964 64.4624 165.207 64.4624L20.9926 64.4624C18.2357 64.4624 16.0007 62.2275 16.0007 59.4705L16.0007 37.9595L170.199 37.9595L170.199 59.4705Z",
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 224.945,
    y: 120.122,
    width: 42.0716,
    height: 40.2424,
    rx: 7.54349,
    transform: "rotate(-180 224.945 120.122)",
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0273,
    y: 46.3921,
    width: 51.801,
    height: 8.43273,
    rx: 4.21636,
    fill: "#A3BBD1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.002 85.1149C16.002 82.358 18.2369 80.123 20.9938 80.123H165.209C167.965 80.123 170.2 82.358 170.2 85.1149V93.3745H16.002V85.1149Z",
    fill: "#B9C7D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.199 114.886C170.199 117.643 167.964 119.877 165.207 119.877L20.9926 119.877C18.2357 119.877 16.0007 117.642 16.0007 114.886L16.0007 93.3746L170.199 93.3746L170.199 114.886Z",
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0273,
    y: 101.807,
    width: 38.5496,
    height: 8.43273,
    rx: 4.21636,
    fill: "#A3BBD1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 69.0117,
    y: 101.807,
    width: 38.5496,
    height: 8.43273,
    rx: 4.21636,
    fill: "#A3BBD1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.002 140.53C16.002 137.773 18.2369 135.538 20.9938 135.538H165.209C167.965 135.538 170.2 137.773 170.2 140.53V148.79H16.002V140.53Z",
    fill: "#B9C7D7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M170.199 170.301C170.199 173.058 167.964 175.292 165.207 175.292L20.9926 175.292C18.2357 175.292 16.0007 173.058 16.0007 170.301L16.0007 148.79L170.199 148.79L170.199 170.301Z",
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0273,
    y: 157.223,
    width: 138.538,
    height: 8.43273,
    rx: 4.21636,
    fill: "#A3BBD1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M201.627 104.45L197.924 100.748C197.508 100.331 196.836 100.331 196.42 100.748C196.003 101.164 196.003 101.836 196.42 102.252L200.88 106.712C201.296 107.128 201.968 107.128 202.384 106.712L213.673 95.4231C214.09 95.0069 214.09 94.3347 213.673 93.9186C213.257 93.5024 212.585 93.5024 212.169 93.9186L201.627 104.45Z",
    fill: "#003A70"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 120.122,
    width: 42.0716,
    height: 40.2424,
    rx: 7.54349,
    transform: "rotate(-180 278 120.122)",
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M248.271 105.826V109.07C248.271 109.369 248.506 109.604 248.805 109.604H252.049C252.187 109.604 252.326 109.55 252.422 109.444L264.074 97.8024L260.073 93.801L248.432 105.442C248.325 105.549 248.271 105.677 248.271 105.826ZM267.169 94.708C267.585 94.2919 267.585 93.6196 267.169 93.2035L264.672 90.7066C264.256 90.2905 263.583 90.2905 263.167 90.7066L261.215 92.6593L265.216 96.6607L267.169 94.708Z",
    fill: "#003A70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard5);
export default __webpack_public_path__ + "static/media/card5.3fc183e332e2d80130dc1ab961de9024.svg";
export { ForwardRef as ReactComponent };